import http from "../../http-common";

const createBank = async (bankData) => {
  return await http
    .post("/admin/banks/create-bank", bankData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateBank = async (bankId, bankData) => {
  return await http
    .put(`/admin/banks/update-bank/${bankId}`, bankData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadBankImage = async (bankId, formData) => {
  return await http
    .post(
      `/admin/banks/upload-bank-image/${bankId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getAllBanks = async () => {
  return await http
    .get("/admin/banks")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  createBank,
  updateBank,
  uploadBankImage,
  getAllBanks,
}; 